/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=53694c22&scoped=true&"
import script from "./summary.vue?vue&type=script&lang=js&"
export * from "./summary.vue?vue&type=script&lang=js&"
import style0 from "./summary.vue?vue&type=style&index=0&id=53694c22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53694c22",
  null
  
)

export default component.exports